//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SfButton from "../../../atoms/SfButton/SfButton.vue";
import SfHeading from "../../../atoms/SfHeading/SfHeading.vue";
import { focus } from "../../../../utilities/directives";
import SfIcon from "~/themes/fiskarsMoominDefault/components/components/atoms/SfIcon/SfIcon.vue";
export default {
  name: "SfFooterColumn",
  directives: { focus },
  components: {
    SfButton,
    SfHeading,
    SfIcon
},
  props: {
    title: {
      type: String,
      default: "",
    },
  },
  inject: ["items"],
  data() {
    return {
      isColumnOpen: true,
    };
  },
  watch: {
    "$parent.isOpen": {
      handler(newVal) {
        this.isColumnOpen = newVal.includes(this.title);
      },
      immediate: true,
    },
  },
  created() {
    this.items.push(this.title);
  },
  methods: {
    toggle(payload) {
      this.$parent.toggle(payload);
    },
  },
};
